module.exports = __webpack_public_path__ + "img/la_paraguaya.9722f027.png";